import { Injectable, signal } from '@angular/core';

/**
 * POS Test Mode (onboarding) — read-only reflection of the backend's
 * per-request decision.
 *
 * Test Mode is a per-store onboarding configuration (`StoreSetting.PosTestMode`)
 * resolved server-side; the SPA never decides it. The backend echoes the
 * current state on every POS response via the `X-Test-Mode` header, which
 * {@link testModeInterceptor} reads to update this signal — so the persistent
 * TEST banner appears as soon as the terminal makes its first POS call and
 * clears within one request after an admin "Switch to Live".
 */
@Injectable({ providedIn: 'root' })
export class TestModeService {
  private readonly _isTestMode = signal(false);
  /** Reactive flag — true while the current store is in Test Mode. */
  readonly isTestMode = this._isTestMode.asReadonly();

  /** Set from the X-Test-Mode response header by the interceptor. */
  set(isTest: boolean): void {
    this._isTestMode.set(isTest);
  }
}
